import { Facet } from "@/types/productListing";

type AppliedFilter = {
  facetName: string;
  label: string;
  trackingId: string;
  facetUrl: string;
};

export function extractAppliedFilters(facets: Facet[]): {
  appliedFilters: AppliedFilter[];
  combination: string;
  trackingIds: string;
} {
  const selectedFacets = facets.filter((f) =>
    f.details.some((detail) => detail.isSelected === "true"),
  );

  const appliedFilters = selectedFacets.reduce<AppliedFilter[]>(
    (acc, facet) => {
      const selectedDetails = facet.details.filter((detail) => {
        return detail.isSelected === "true";
      });

      if (!selectedDetails.length) return acc;

      return [
        ...acc,
        ...selectedDetails.map(
          (detail) =>
            ({
              facetName: facet.name,
              label: detail.label,
              trackingId: detail.trackingId || "",
              facetUrl: detail.facetUrl || "",
            }) satisfies AppliedFilter,
        ),
      ];
    },
    [],
  );

  const combination = appliedFilters
    .map((f) => `${f.facetName}:${f.label}`.toLowerCase())
    .join("|");

  const trackingIds = appliedFilters.map((f) => f.trackingId).join("|");

  return { appliedFilters, combination, trackingIds };
}

type Query = Record<string, string | string[] | undefined>;

export function removePriceFilter(query: Query, priceNval: string): Query {
  const priceValue = priceNval.split("=")[1];
  if (!priceValue) return query;

  const newQuery: Query = {};
  for (const [key, value] of Object.entries(query)) {
    if (key === "price") {
      const newPriceValue = String(value)
        .split(",")
        .filter((v) => v !== priceValue)
        .join(",");
      if (newPriceValue) {
        newQuery["price"] = newPriceValue;
      }
    } else {
      newQuery[key] = value;
    }
  }

  if (!("price" in newQuery)) {
    delete newQuery.priceBands;
  }

  return newQuery;
}

export function removeAllPriceQueries(query: Query): Query {
  const newQuery: Query = {};
  for (const [key, value] of Object.entries(query)) {
    if (key !== "price" && key !== "priceBands") {
      newQuery[key] = value;
    }
  }
  return newQuery;
}
